/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Dots_LabelInputs */



/**
* | output |
* | --- |
* | "2 or 4+ dots" |
*
* @param {Style_Guide_Manager_Dots_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_dots_label = /** @type {((inputs?: Style_Guide_Manager_Dots_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Dots_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("2 ou 4+ points")
	if (locale === "de") return /** @type {LocalizedString} */ ("2 oder 4+ Punkte")
	if (locale === "it") return /** @type {LocalizedString} */ ("2 o 4+ punti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("2 или 4+ точек")
	if (locale === "es") return /** @type {LocalizedString} */ ("2 o 4+ puntos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("2 或 4 个以上点")
	if (locale === "ja") return /** @type {LocalizedString} */ ("2つまたは4つ以上のドット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("2 या 4+ बिंदु")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("2 ou 4+ pontos")
	return /** @type {LocalizedString} */ ("2 or 4+ dots")
});